import { motion } from "framer-motion";
import img1 from "./assets/raw.jpg";
import img2 from "./assets/expect.jpg";
import img3 from "./assets/daily.jpg";
import bgPattern from "./assets/bg-patternn.svg"; 

  const fadeInUp = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: "easeOut" } },
};

const TimeAssignment = () => {
    return (
 <section className="relative w-full py-20 font-epilogue bg-[#F5F7F9] overflow-hidden">
  <img
    src={bgPattern}
    alt="Background Pattern"
    className="absolute inset-0 w-full h-full object-cover opacity-55 pointer-events-none z-0"
  />
  <div className="relative max-w-[1200px] mx-auto px-6 lg:px-12 z-10">
    <motion.h2
      className="text-3xl lg:text-4xl font-semibold text-center mb-16 text-gray-900"
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
      variants={fadeInUp}
    >
      What is Automated Work  <br className="hidden sm:block" /> Allocation & Assignment?
    </motion.h2>
    <div className="relative flex flex-col gap-24">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
        <motion.div
          className="flex flex-col text-left md:pr-12"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={fadeInUp}
        >
          <h3 className="text-lg font-semibold text-gray-900 mb-2">
            Raw Clocking
          </h3>
          <p className="text-gray-600 leading-relaxed text-base">
            JIVIEWS can be integrated to access and time clock systems to capture In and Out times of employees
          </p>
        </motion.div>
        <motion.div
          className="overflow-hidden rounded-2xl shadow-md"
          initial={{ opacity: 0, x: 80 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, ease: 'easeOut' }}
        >
          <img
            src={img1}
            alt="Employee Leave Management"
            className="w-full h-full object-cover transform transition-transform duration-700 ease-out hover:scale-110"
          />
        </motion.div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
        <motion.div
          className="overflow-hidden rounded-2xl shadow-md order-2 md:order-1"
          initial={{ opacity: 0, x: -80 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, ease: 'easeOut' }}
        >
          <img
            src={img2}
            alt="Work Schedule"
            className="w-full h-full object-cover transform transition-transform duration-700 ease-out hover:scale-110"
          />
        </motion.div>
        <motion.div
          className="flex flex-col text-left md:pl-12 order-1 md:order-2"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={fadeInUp}
        >
          <h3 className="text-lg font-semibold text-gray-900 mb-2">
            Exceptions
          </h3>
          <p className="text-gray-600 leading-relaxed text-base">
            Exceptions can be defined to alert managers of wrongful attendance such as lateness, missed punches, etc.
          </p>
        </motion.div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
        <motion.div
          className="flex flex-col text-left md:pr-12"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={fadeInUp}
        >
          <h3 className="text-lg font-semibold text-gray-900 mb-2">
            Daily Attendance
          </h3>
          <p className="text-gray-600 leading-relaxed text-base">
            Tracks daily attendance based on scheduled work and clock punches to verify legitimate work hours inclusive of Overtime.
          </p>
        </motion.div>
        <motion.div
          className="overflow-hidden rounded-2xl shadow-md"
          initial={{ opacity: 0, x: 80 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, ease: 'easeOut' }}
        >
          <img
            src={img3}
            alt="Employee Empowerment"
            className="w-full h-full object-cover transform transition-transform duration-700 ease-out hover:scale-110"
          />
        </motion.div>
      </div>
    </div>
  </div>
</section>
    );
};

export default TimeAssignment;